export const AI_CONFIG = {
  openai: {
    model: "gpt-4o",
    settings: {
      response_format: {
        type: "text"
      },
      temperature: 1,
      max_completion_tokens: 16383,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0
    }
  },
  similarity: {
    threshold: 0.7 // Minimum similarity score to consider as a potential match
  }
} as const;